var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',[_c('b',[_vm._v("Space Divisor active percentage: "+_vm._s(_vm.formatInt(_vm.percentage))+"%. Changing requires a Big Crunch Reset.")]),_c('SliderComponent',_vm._b({attrs:{"value":_vm.percentage},on:{"input":function($event){return _vm.adjustSliderValue($event)}}},'SliderComponent',_vm.sliderProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }